import { Directive, HostListener } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NgControl } from '@angular/forms';

@UntilDestroy()
@Directive({
  standalone: false,
  selector: '[sscCapitalize]',
})
export class CapitalizeDirective {
  constructor(public ngControl: NgControl) {}

  @HostListener('blur', ['$event'])
  public onBlur(event: FocusEvent): void {
    if (event.currentTarget) {
      const target = event.currentTarget as HTMLInputElement;
      if (target.value.length > 0) {
        const inputValue = target.value;
        this.ngControl.control?.setValue(inputValue.charAt(0).toUpperCase() + inputValue.substring(1));
      }
    }
  }
}
